import { Helmet } from 'react-helmet-async';
import { useEffect, useState, useRef } from 'react';
import {
  Box,
  Card,
  InputBase,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Input,
  Select,
  TableHead,
  DialogContentText,
  Checkbox,
  ListItemText,
  Chip,
  InputLabel,
  FormControl,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
// mock
import USERLIST from '../_mock/user';
import { deleteData, getData, postData, postDataBulkUpload, putData } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { toast } from 'react-toastify';

// ----------------------------------------------------------------------

export default function LeadsPage() {
  const [leads, setLeads] = useState([]);
  const [open, setOpen] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [updatedData, setUpdatedData] = useState({});
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const sessionToken = sessionStorage.getItem("Token");

  const [details, setDetails] = useState(false);
  const [scroll, setScroll] = useState('paper');
  const descriptionElementRef = useRef(null);

  const [isChecked, setIsChecked] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const [file, setFile] = useState(null);

  const [query, setQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [assignFormData, setAssignFormData] = useState({
    generalStatus: '',
    serviceName: 'Sales',
    startDate: '',
    duration: '',
    callHistory: '',
    requirement: '',
    assignedTo: [],
    serviceStatus: '',
    progress: '',
    quotationFile: null
  })

  const handleClickOpen = (scrollType, leadId) => () => {
    const lead = leads.find((data) => data._id === leadId);
    setDetails(true);
    setScroll(scrollType);
    setOpen(null)
  };

  const handleClose = () => {
    setDetails(false);
    setSelectedLead(null);
  };

  useEffect(() => {
    if (details) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [details]);

  const handleOpenMenu = (event, id) => {
    const lead = leads.find((data) => data._id === id);
    if (event?.currentTarget) {
      setOpen(event.currentTarget);
      setSelectedLeadId(id);
      setSelectedLead(lead);
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const getAllLeads = async () => {

    const params = {
      page: currentPage,
      limit: limit
    }

    try {
      console.log("Fetching users...");
      console.log("Token being sent:", sessionToken);

      const response = await getData("leads/leads", params, sessionToken);
      console.log("Response:", response)

      const responseData = response.data.results[0]?.paginatedResults;

      setLeads(responseData);
      setTotalCount(response.data.results[0].totalCount);
      setTotalPages(response.data.results[0].totalPages);

    } catch (error) {
      console.error("Error fetching users:", error);
    }

  }

  const getAllUsers = async () => {
    try {
      const params = { page: 1, limit: 1000 }
      const response = await getData("users/users", params, sessionToken);
      console.log("Response:", response);

      if (response?.data?.results) {
        // Filter for sales users
        const filteredUsers = response.data.results.filter(user =>
          user.role === "Sales"
        );
        console.log("Filtered sales employees:", filteredUsers);
        setUsers(filteredUsers);

        if (filteredUsers.length > 0) {
          setAssignFormData(prev => ({
            ...prev,
            assignedTo: filteredUsers[0]._id
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Failed to load users");
    }
  };

  useEffect(() => {
    getAllLeads(currentPage, limit);
  }, [currentPage, limit])


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    password: '',
    role: '',
  })

  const postLeads = async (e) => {
    debugger
    const newUser = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      company: formData.company,
      location: formData.location,
      source: formData.source,
      summary: formData.summary
    };

    try {
      const response = await postData("leads/lead/create", newUser, sessionToken);

      if (response?.status === 200) {
        setFormOpen(false);
        toast.success("Leads Created Successfully!")
        getAllLeads();
      } else {
        throw new Error(response?.message || "Failed to add lead.");
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again!");
    }
    setFormData({})
    // await getAllLeads();
  }

  const handleChange = (id, field, value) => {
    setUpdatedData((prev) => ({
      ...prev,
      [id]: { ...(prev[id] || {}), [field]: value },
    }));
  };

  const handleEditClick = (id) => {
    handleCloseMenu();
    const lead = leads.find((leads) => leads._id === id);
    setEditRow(id);
    setUpdatedData((prev) => ({
      ...prev,
      [id]: { ...lead } || {}
    }));
  };

  const handleSaveChanges = (id) => {
    setLeads((prev) =>
      prev.map((leads) =>
        leads._id === id ? { ...leads, ...(updatedData[id] || {}) } : leads
      )
    );
    setUpdatedData((prev) => {
      const newData = { ...prev };
      delete newData[id]; // Clear saved data for this lead
      return newData;
    });
    setEditRow(null);
  };

  const handleDelete = async (id) => {
    debugger;
    if (!id) {
      console.error("User ID is undefined.");
      return;
    }
    try {
      const response = await deleteData(`leads/lead/${id}`, sessionToken);
      console.log(response.message);
      toast.success("User deleted successfully!");
      setLeads((prevUsers) => prevUsers.filter((user) => user.id !== id));
    } catch (error) {
      console.error("Error deleting user:", error.message);
      toast.error(error.message);
    }
    getAllLeads();
  };

  const handleLimitChange = (event) => {
    setCurrentPage(1);
    if (currentPage === 1) {
      setLimit(event.target.value)
      getAllLeads(1, event.target.value)
    }
    else {
      setCurrentPage(1);
      setLimit(event.target.value);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      getAllLeads(currentPage - 1, limit);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      getAllLeads(currentPage + 1, limit);
    }
  };

  const calculateIndex = (index) => {
    return (currentPage - 1) * limit + index + 1;
  };

  const handleCheckboxChange = (event, id) => {
    setIsChecked({ ...isChecked, [id]: event.target.checked });
  };

  const handleSelectAllCheckboxChange = (event) => {
    const { checked } = event.target;
    const updatedIsChecked = {};
    leads.forEach((row) => {
      updatedIsChecked[row?._id] = checked;
    });
    setIsChecked(updatedIsChecked);
    setSelectAllChecked(checked);
  };

  const unselectAllCheckboxes = () => {
    const updatedIsChecked = {};
    leads?.forEach((row) => {
      updatedIsChecked[row._id] = false;
    });
    setIsChecked(updatedIsChecked);
    setSelectAllChecked(false);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      toast.error("Please upload a valid .xlsx file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file); // 'file' should match the API key

    try {
      const response = await postDataBulkUpload("leads/import", formData, sessionToken);
      toast.success("File uploaded successfully!");
      await getAllLeads();
      console.log(response.data);
    } catch (error) {
      toast.error("Error uploading file!");
      console.error(error);
    }
  };

  const handleAssignSubmit = async () => {
    try {
      debugger;
      const sessionToken = sessionStorage.getItem("Token");

      if (!sessionToken) {
        toast.error("Authentication Error! Please login again.");
        return;
      }

      // Prepare the payload similar to your putService example
      const putPayload = {
        generalStatus: 'Follow-up Needed',
        serviceName: ['Sales'], // Hardcoded as per your requirement
        startDate: assignFormData.startDate,
        duration: assignFormData.duration,
        callHistory: assignFormData.callHistory,
        requirement: assignFormData.requirement,
        assignedTo: Array.isArray(assignFormData.assignedTo)
          ? assignFormData.assignedTo
          : [assignFormData.assignedTo],
        serviceStatus: 'In Progress',
        progress: assignFormData.progress,
        // Include file if uploaded
        ...(assignFormData.quotationFile && { quotationFileObject: assignFormData.quotationFile })
      };

      // Add any conditional fields like your SEO example
      if (assignFormData.serviceName?.includes("SEO")) {
        putPayload.seoType = assignFormData.seoType || null;
      }

      const putResponse = await putData(
        `leads/lead/${selectedLeadId}/status`,
        putPayload,
        sessionToken
      );

      if (putResponse?.data?._id) {
        toast.success("Lead assigned successfully!");

        // Update local state if needed
        setLeads(prev =>
          prev.map(lead =>
            lead._id === selectedLeadId ? { ...lead, ...putPayload } : lead
          )
        );

        // Close dialogs and reset form
        setAssignDialogOpen(false);
        setAssignFormData({
          generalStatus: '',
          serviceName: 'Sales',
          startDate: '',
          duration: '',
          callHistory: '',
          requirement: '',
          assignedTo: users.length > 0 ? users[0]._id : '',
          serviceStatus: 'In Progress',
          progress: '',
          quotationFile: null
        });

        // Refresh leads data
        await getAllLeads();
        return;
      }

      throw new Error(putResponse?.message || "Assignment failed");
    } catch (error) {
      console.error("Assignment error:", error);
      toast.error(error.message || "Failed to assign lead");
    }
  };

  console.log(selectedLead, 'selected Leads')

  return (
    <>
      <Helmet>
        <title>Leads</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Leads
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "4px 12px",
                boxShadow: 1,
                marginRight: "20px"
              }}
            >
              <Iconify icon="eva:search-fill" />
              <InputBase
                placeholder="Search"
                sx={{ marginLeft: "8px" }}
              />
            </Box>
            <Button variant="contained" sx={{ marginRight: "10px" }} startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setFormOpen(true)}>
              Lead
            </Button>
            {
              !file && (
                <Button variant="contained" component='label'>
                  Bulk Upload <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} sx={{ maxWidth: 100 }} hidden />
                </Button>
              )
            }
            {file && (
              <>
                <Button variant="contained" component='label' startIcon={<Iconify icon="mdi:cloud-upload" />} onClick={handleUpload}>
                  {file.name}
                </Button>
              </>
            )}
          </Box>
        </Stack>

        <Card sx={{ padding: 1, boxShadow: 3, backgroundColor: "#fff" }}>
          <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
            <Table>
              <TableHead>
                <TableCell>
                  <div
                    className="color-white"
                    checked={selectAllChecked}
                    onChange={handleSelectAllCheckboxChange}
                  />
                  S.No
                </TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Contact</TableCell>
                <TableCell>E-Mail</TableCell>
                <TableCell>Company</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Source</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                {/* <TableCell>Call History</TableCell> */}
                {/* <TableCell>Appointment</TableCell> */}
                <TableCell></TableCell>
              </TableHead>
              <TableBody>
                {
                  leads.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  ) : (
                    leads.map((leads, id) => {
                      return (
                        <TableRow key={leads._id}>
                          <TableCell>
                            <div
                              checked={isChecked[leads._id] || false}
                              onChange={(event) =>
                                handleCheckboxChange(event, leads._id)
                              }
                            />
                            {calculateIndex(id)}
                          </TableCell>
                          <TableCell> {leads?.name}
                          </TableCell>
                          <TableCell>{leads.phone}</TableCell>
                          <TableCell>{leads.email}</TableCell>
                          <TableCell>{leads.company}</TableCell>
                          <TableCell>{leads.location}</TableCell>
                          <TableCell>
                            {leads.source}
                            {leads.summary && ` (${leads.summary})`}
                          </TableCell>
                          <TableCell>
                            <Chip label={!leads.assignedTo ? "Not Assigned" : "Assigned"} size='small' sx={{ fontSize: "8px" }} />
                          </TableCell>
                          <TableCell>{new Date(leads.createdAt).toLocaleDateString()}</TableCell>
                          {/* <TableCell>{leads?.callHistory?.summary}</TableCell> */}
                          {/* <TableCell>
                            {leads?.callHistory?.appoinmentDate
                              ? new Date(leads.callHistory.appoinmentDate).toLocaleDateString('en-GB')
                              : "-"}
                          </TableCell> */}

                          <TableCell>
                            <Iconify icon="mdi:dots-vertical" sx={{ margin: "auto" }} onClick={(event) => handleOpenMenu(event, leads._id)} />
                          </TableCell>
                        </TableRow>
                      )
                    })
                  )
                }
              </TableBody>
            </Table>
          </TableContainer>
          <PaginationComponent
            name={"Leads"}
            totalcount={totalCount}
            limit={limit}
            handleLimitChange={handleLimitChange}
            handlePrevPage={handlePrevPage}
            handleNextPage={handleNextPage}
            currentPage={currentPage}
            totalPages={totalPages}
          />
        </Card>

        {/* Dialog Event  */}
        <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
          <DialogTitle>Add Lead</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              label="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Phone Number"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              fullWidth
            />
            <TextField
              margin="dense"
              label="Company"
              value={formData.company}
              onChange={(e) => setFormData({ ...formData, company: e.target.value })}
              fullWidth
            >
            </TextField>
            <TextField
              margin="dense"
              label="Location"
              value={formData.location}
              onChange={(e) => setFormData({ ...formData, location: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            >
            </TextField>
            <TextField
              select
              label="Source"
              value={formData.source}
              onChange={(e) => setFormData({ ...formData, source: e.target.value })}
              fullWidth
              sx={{ mb: 2 }}
            >
              <MenuItem value="Expo">Expo</MenuItem>
              <MenuItem value="Advertisement">Advertisement</MenuItem>
              <MenuItem value="Reference">Reference</MenuItem>
              <MenuItem value="Others">Others</MenuItem>
            </TextField>
            {formData.source === 'Others' && (
              <TextField
                label="Please Specify"
                value={formData.summary || ''}
                onChange={(e) => setFormData({ ...formData, summary: e.target.value })}
                fullWidth
                sx={{ mb: 2 }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFormOpen(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={postLeads} color="primary">
              Add Lead
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={assignDialogOpen} onClose={() => setAssignDialogOpen(false)}>
          <DialogTitle>Assign Lead</DialogTitle>
          <DialogContent>
            <Box sx={{ minWidth: 400, mt: 1 }}>
              <FormControl fullWidth>
                <InputLabel id="assign-to-label">Assign To</InputLabel>
                <Select
                  multiple
                  labelId="assign-to-label"
                  sx={{ mb: 2 }}
                  value={Array.isArray(assignFormData.assignedTo) ? assignFormData.assignedTo : []}
                  onChange={(e) => {
                    // Ensure we always get an array
                    const value = Array.isArray(e.target.value) ? e.target.value : [e.target.value];
                    setAssignFormData({
                      ...assignFormData,
                      assignedTo: value
                    });
                  }}
                  fullWidth
                  margin="normal"
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {(Array.isArray(selected) ? selected : []).map((userId) => {
                        const user = users.find(u => u._id === userId);
                        return user ? (
                          <Chip key={userId} label={user.name} />
                        ) : null;
                      })}
                    </Box>
                  )}
                >
                  {users.map((user) => (
                    <MenuItem key={user._id} value={user._id}>
                      <Checkbox
                        checked={
                          Array.isArray(assignFormData.assignedTo) &&
                          assignFormData.assignedTo.includes(user._id)
                        }
                      />
                      <ListItemText primary={user.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setAssignDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleAssignSubmit} color="primary">Submit</Button>
          </DialogActions>
        </Dialog>

      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/* <MenuItem onClick={handleClickOpen('paper')}>
          <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
          View
        </MenuItem> */}

        {(!selectedLead?.assignedTo) && (
          <MenuItem
            onClick={() => {
              getAllUsers();
              setAssignDialogOpen(true);
              handleCloseMenu();
            }}
          >
            <Iconify icon="mdi:account-plus" sx={{ mr: 2 }} />
            Assign To
          </MenuItem>
        )}
        <MenuItem sx={{ color: 'error.main' }}
          onClick={() => {
            if (!selectedLeadId) {
              toast.error('No user selected. Please try again.');
              return;
            }
            const confirmDelete = window.confirm('Are you sure you want to delete this user?');
            if (confirmDelete) {
              handleDelete(selectedLeadId);
              handleCloseMenu();
            }
          }}
        >
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>

      <Dialog
        open={details}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Leads Details</DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
          // tabIndex={-1}
          >
            {selectedLead ? (
              <>
                <p><strong>Id:</strong> {selectedLead._id}</p>
                <p><strong>Name:</strong> {selectedLead.name}</p>
                <p><strong>Email:</strong> {selectedLead.email}</p>
                <p><strong>Phone:</strong> {selectedLead.phone}</p>
                <p><strong>Company:</strong> {selectedLead.company}</p>
                <p><strong>General Status:</strong> {selectedLead.generalStatus}</p>
                <p><strong>Created At:</strong> {new Date(selectedLead.createdAt).toLocaleString()}</p>
                <p><strong>Updated At:</strong> {new Date(selectedLead.updatedAt).toLocaleString()}</p>
              </>
            ) : (
              <p>No lead selected.</p>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
